import { render, staticRenderFns } from "./LocalstorageLink.vue?vue&type=template&id=3b85d9cb&"
import script from "./LocalstorageLink.vue?vue&type=script&lang=js&"
export * from "./LocalstorageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports